<script lang="ts">
  import CountTo from '$lib/components/CountTo.svelte';
  import StrokeText from '$lib/components/StrokeText.svelte';
  import { getUBarColor } from './getUBarColor';
  import { tweened } from 'svelte/motion';
  import { bounceOut } from 'svelte/easing';

  export let index: number = 0;
  export let percentage: number = 0;

  // bounce at slightly different rates!
  const bounceCoefficient = 1 + (0.25 * Math.random() - 0.25 / 2);

  // Elastic out is also good, but loses the above 100 parts of the bounce
  const sprungPercentage = tweened(0, {
    duration: 1500 * bounceCoefficient,
    easing: bounceOut,
  });

  $: sprungPercentage.set(percentage / 100);

  $: color = getUBarColor(index);
  $: stroke = color[700];
</script>

<!-- This is the complete div, w/ very light bg -->
<div
  class="relative h-full text-white overflow-x-hidden"
  style="background-color: {color[50]};
    "
>
  <!-- This div is the % completed with dark bg -->
  <div class="h-full" style="background-color: {color[500]}; width: {$sprungPercentage * 100}%;">
    &nbsp;
  </div>

  <!-- This div holds the title & percent -->
  <div class="absolute w-full vertically-center px-2 overflow-y-visible">
    <StrokeText strokeColor={stroke} class="flex">
      <div class="flex-grow self-center whitespace-nowrap overflow-x-scroll overflow-y-hidden">
        <slot />
      </div>
      <div class="ml-2 self-center"><CountTo value={percentage} />%</div>
    </StrokeText>
  </div>
</div>

<style lang="postcss">
  .vertically-center {
    transform: translateY(-50%);
    top: 50%;
  }

  ::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    height: 0;
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  /* Optional: show position indicator in red */
  ::-webkit-scrollbar-thumb {
    width: 0;
    height: 0;
    background: transparent;
  }
</style>
